// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class TopicController {
   $scope: any
   feed: any
   topics: any
   util: any
   constructor($scope: any, topics: any, util: any, feed: any) {
      this.wrapInQuotes = this.wrapInQuotes.bind(this)
      this.displayTopics = this.displayTopics.bind(this)
      this.$scope = $scope
      this.topics = topics
      this.util = util
      this.feed = feed
      this.$scope.topic = this.topics.scope
      this.$scope.wrapInQuotes = this.wrapInQuotes
      this.$scope.displayTopics = this.displayTopics
   }

   wrapInQuotes(s: any) {
      const escaped = this.util.summonEscape(s)
      return '"' + escaped + '"'
   }

   displayTopics() {
      return this.$scope.topic.visible
   }
}

TopicController.$inject = ['$scope', 'topicService', 'utilitiesService', 'resultsFeedService']

angular.module('summonApp.controllers').controller('TopicCtrl', TopicController)
